import './flex-container.less';
import {classNames} from "utils/helpers";
import { PropsWithChildren } from 'react';

export default function FlexContainer(props: PropsWithChildren<{
  className?: string
  centerVertically?: boolean
  centerHorizontally?: boolean
  vertical?: boolean
}>)
{
  return <div className={classNames(props.className, {
    'flex-container': true,
    'center-horizontally': props.centerHorizontally,
    'center-vertically': props.centerVertically,
    'vertical': props.vertical,
  })}>
    {props.children}
  </div>
}